import { render } from "./BreadTag.vue?vue&type=template&id=57037f29&scoped=true"
import script from "./BreadTag.vue?vue&type=script&lang=js"
export * from "./BreadTag.vue?vue&type=script&lang=js"

import "./BreadTag.vue?vue&type=style&index=0&id=57037f29&lang=scss&scoped=true"
import "./BreadTag.vue?vue&type=style&index=1&id=57037f29&lang=scss"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57037f29"]])

export default __exports__